import { useGetAvailableTimezonesQuery } from '../../Language/hooks/useGetAvailableTimezonesQuery';
import { useGetRegionalAndLanguageSettingsQuery } from '../../Language/hooks/useGetRegionalAndLanguageSettingQuery';

export interface IRegionalShortDateTimeFormatData {
  readonly timezonePreferenceOffset: number | null;
  readonly dateFormat: string;
  readonly timeFormat: string;
}

export const useRegionalShortDateTimeFormatData = (): IRegionalShortDateTimeFormatData => {
  const { regionalFormatOverrides } = useGetRegionalAndLanguageSettingsQuery();
  const availableTimezonesQuery = useGetAvailableTimezonesQuery();

  let timeOffsetInMs = null;
  if (regionalFormatOverrides.timeZone) {
    const timezone = availableTimezonesQuery.data?.find(
      (timezone) => timezone.alias === regionalFormatOverrides.timeZone,
    );
    // Convert timezone display name to time offset
    // e.g. "(UTC-08:00) Pacific Time (US & Canada)"
    const utcOffsetRegex = /UTC([+-]\d{2}:\d{2})/;
    const utcOffsetMatch = timezone?.displayName.match(utcOffsetRegex);
    const utcOffset = utcOffsetMatch && utcOffsetMatch.index ? utcOffsetMatch[utcOffsetMatch.index] : null;
    // timeOffsetInMs will be 0 for for "(UTC) Coordinated Universal Time"
    const utcOffsetHour = utcOffset ? parseInt(utcOffset.split(':')[0]) : 0;
    const utcOffsetMinute = utcOffset ? parseInt(utcOffset.split(':')[1]) : 0;
    timeOffsetInMs = utcOffsetHour * 60 * 60 * 1000 + utcOffsetMinute * 60 * 1000;
  }

  return {
    timezonePreferenceOffset: timeOffsetInMs,
    dateFormat: regionalFormatOverrides.shortDateFormat || '',
    timeFormat: regionalFormatOverrides.shortTimeFormat || '',
  };
};
